import React from 'react';

import Register from './Register';

const InspectorRegister = () => <Register isInspector={true} />;

export default InspectorRegister;
